import { render, staticRenderFns } from "./Vir.vue?vue&type=template&id=72007e5e&scoped=true&"
import script from "./Vir.vue?vue&type=script&lang=js&"
export * from "./Vir.vue?vue&type=script&lang=js&"
import style0 from "./Vir.vue?vue&type=style&index=0&id=72007e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72007e5e",
  null
  
)

export default component.exports